import { render, staticRenderFns } from "./QuizQuestion.vue?vue&type=template&id=455ed756"
import script from "./QuizQuestion.vue?vue&type=script&lang=js"
export * from "./QuizQuestion.vue?vue&type=script&lang=js"
import style0 from "./QuizQuestion.vue?vue&type=style&index=0&id=455ed756&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports